/* eslint-disable react-hooks/exhaustive-deps */
import * as Yup from "yup";
import { User, UserType } from "./api/user/user.type";
// TODO: Remplacer par une image d'avatar par défaut si nécessaire
// import Avatar from "../assets/appImages/default.jpeg";
import DefaultImage from "../assets/appImages/logo.svg";
import { ApiBaseUrl } from "./http";
import $ from "jquery";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useMemo } from "react";
import moment from "moment";
// import { Modal } from "bootstrap";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useAppSelector } from "../redux/hook";
import { isSuperAdmin } from "../routes/routerUtils";
import { PhoneNumberUtil } from "google-libphonenumber";
import { Timestamp } from "firebase/firestore";
import { Feature } from "./api/plan/plan.type"
import { Subscription } from "./api/subscription/subscription.type";

export const useUser = () => {
  const { user } = useAppSelector((s) => s?.auth);

  return user as User;
};

export const useSubscription = () => {
  const { data } = useAppSelector((s) => s?.subscription);

  return data as Subscription | null;
}

const phoneUtil = PhoneNumberUtil.getInstance();

export function validateNumber(phone?: string, country?: string) {
  if (!phone || !country) return true;
  try {
    const number = phoneUtil.parse(phone, country);
    if (phoneUtil.isPossibleNumber(number) && phoneUtil.isValidNumber(number)) {
      return true;
    }
  } catch (ex) {
    console.log("error phone", ex);
  }
  return false;
}

export function validatePhone(yup: typeof Yup, country: string) {
  return yup
    .string()
    .test("passwords-match", "Numéro téléphone invalide", (val) =>
      validateNumber(val, country)
    )
    .label("Le téléphone")
    .nullable();
}

export function validatePassword(Yup: any) {
  return Yup.string()
    .required("Le mot de passe est obligatoire ")
    .matches(/[a-z]+/, "Le mot de passe doit avoir au moins une minuscule.")
    .matches(/[A-Z]+/, "Le mot de passe doit avoir au moins une majuscule.")
    .matches(
      /[!@#$%^&*(),;-_+*/.?":{}|<>]+/,
      "Le mot de passe doit avoir au moins un caractère spécial"
    )
    .matches(/\d+/, "Le mot de passe doit avoir au moins un chiffre.")
    .min(8, "Le mot de passe doit être supérieur à 5 caractére");
  //.label("Le mot de passe");
}

export function useLocationState<T>(
  defaultValue: T | any,
  redirectToWhenNull: string | null = null
): T {
  const state = useLocation().state as T;
  const navigate = useNavigate();
  useEffect(() => {
    if (!state && redirectToWhenNull) {
      navigate(redirectToWhenNull);
    }
  }, [state]);
  return state || defaultValue;
}
export function createMarkup(
  text: string | any,
  showDots?: boolean,
  numberSlice?: number
) {
  return {
    __html: `${numberSlice ? text.slice(0, numberSlice) : text}${showDots === true ? "..." : ""
      }`,
  };
}
export function readMarkup(
  text: string | any,
  showDots?: boolean,
  numberSlice?: number
) {
  let content = text ? text.replace(/<.+?>/g, "") : text;
  return {
    __html: `${numberSlice ? content.slice(0, numberSlice) : content}${showDots === true ? "..." : ""
      }`,
  };
}

export function cleannerError(
  errors: any,
  cleanner: any,
  timeOut: number = 3000
) {
  if (errors) {
    setTimeout(
      () => Object.entries(errors).map(([key]: any) => cleanner(key)),
      timeOut
    );
  }
}

export function isRH(user: any) {
  if (!user) return false;
  return ["rh"].includes(user.user_type);
}

export function QueryUrl(baseUrl: string, additionalSearchQuery: any) {
  if (additionalSearchQuery) {
    for (let key of Object.keys(additionalSearchQuery)) {
      let val = additionalSearchQuery[key];

      if (Array.isArray(val)) {
        if (val.length > 0) {
          const string = val.map((v) => `${key}=${v}`).join("&");
          if (baseUrl.includes("?")) {
            baseUrl += `&${string}`;
          } else {
            baseUrl += `?${string}`;
          }
        }
      } else if (typeof val === "boolean") {
        if (baseUrl.includes("?")) {
          baseUrl += `&${key}=${val}`;
        } else {
          baseUrl += `?${key}=${val}`;
        }
      } else {
        if (val) {
          if (baseUrl.includes("?")) {
            baseUrl += `&${key}=${val}`;
          } else {
            baseUrl += `?${key}=${val}`;
          }
        }
      }
    }
  }
  return baseUrl;
}


export const getAvatar = (user: User | any) => {
  if (user?.photoURL) {
    return user.photoURL;
  }
  return `https://ui-avatars.com/api/?name=${user?.fullName || user?.userName || "User"}&background=random&size=128`;
};

export const getImage = (image: string | any) => {
  if (image) {
    return image;
  }
  // TODO: Remplacer par une image de couverture par défaut si nécessaire
  // return defaultCover;
  return DefaultImage; // Utilisation temporaire de l'image par défaut
};

export function getName(user?: User) {
  if (user) {
    return user?.firstName + " " + user?.lastName;
  }
  return null;
}

export const onShow = (modalId: string) => {
  document.getElementById(modalId)?.classList.add("show");
  $(`#${modalId}`).show();
};

export const countUppercase = (str: any) => {
  if (str.replace(/[^A-Z]/g, "")?.length >= 1) {
    return true;
  }
  return false;
};

export const countLowercase = (str: any) => {
  if (str.replace(/[^a-z]/g, "")?.length >= 1) {
    return true;
  }
  return false;
};

export const countNumber = (str: any) => {
  if (str.replace(/[^0-9]/g, "")?.length >= 1) {
    return true;
  }
  return false;
};

export const countCharacters = (str: any) => {
  if (str?.length >= 8) {
    return true;
  }
  return false;
};

export const countSpecial = (str: any) => {
  const punct = `/[!@#$%^&*()_+\\-=\\[\\]{};':"\\|,.<>\\/?]+/;`;
  let count = 0;
  for (let i = 0; i < str?.length; i++) {
    if (!punct.includes(str[i])) {
      continue;
    }
    count++;
  }
  // return count;
  if (count >= 1) {
    return true;
  }
  return false;
};

export function formatCurrency(number: number | any, currency: string = "EUR") {
  // On crée le formateur à la volée avec la devise passée
  const formatter = new Intl.NumberFormat(undefined, {
    currency: currency,
    style: "currency",
  });

  // Gestion de la sécurité si number n'est pas un chiffre
  const value = typeof number === 'number' ? number : parseFloat(number) || 0;

  return formatter.format(value);
}

export const getFeatureLabel = (feature: Feature) => {
  if (feature.type === 'numeric') {
    // On adapte le texte selon la valeur
    return `${feature.label || feature.name} : Jusqu'à ${feature.value}`;
  }
  return  feature.label || feature.name;
};
export const getAddress = (user: User) => {
  return user?.address;
};

export const formatDateHour = (date: any) => {
  if (!date) return "";
  return moment(date).format("DD/MM/YYYY à HH[h]mm");
};

export const formatDate = (date: any, outputFormat: string = "DD/MM/YYYY") => {
  
  if (!date) return "";
  if (typeof date === "string") {
    date = new Date(date);
  } else if (typeof date === "object" && date !== null) {
    date = formatTimestempToData(date);
  }
  return moment(date).format(outputFormat || "DD/MM/YYYY");
};
export const formatDateToDDMMYYYY = (date: any) => {
  if (!date) return "";
  return moment(date).format("DD-MM-YYYY");
};

// Convertit un numéro de série Excel (nombre de jours depuis le
// 30/12/1899) en date JS. Nécessaire car un fichier .xls/.xlsx lu avec
// XLSX.utils.sheet_to_json({ raw: true }) renvoie les dates comme des
// nombres, pas des chaînes.
export const excelSerialToDate = (serial: number) => {
  const utcDays = Math.floor(serial - 25569);
  const utcValue = utcDays * 86400;
  return new Date(utcValue * 1000);
};

const toIsoDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Normalise une date de naissance (numéro de série Excel, objet Date, ou
// texte) vers le format ISO AAAA-MM-JJ : c'est le format attendu par la
// Cloud Function d'import d'élèves (new Date(...) côté serveur), et surtout
// non ambigu - contrairement à "12/05/2010" qui serait mal interprété par
// un new Date() classique (MM/JJ au lieu de JJ/MM).
export const normalizeDateOfBirth = (value: unknown): unknown => {
  if (value === undefined || value === null || value === "") return value;

  if (typeof value === "number") {
    return toIsoDate(excelSerialToDate(value));
  }

  if (value instanceof Date) {
    return toIsoDate(value);
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return trimmed;

    // Format usuel côté enseignant : JJ/MM/AAAA ou JJ-MM-AAAA.
    const match = trimmed.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
    if (match) {
      const [, day, month, year] = match;
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
    return trimmed;
  }

  return value;
};

// minuscule, sans accents, sans espaces/ponctuation -> tolère "Prénom",
// "prénom élève", "Prenom_Eleve", "PRENOM ELEVE"... Utile pour faire
// correspondre les en-têtes d'un fichier importé (Excel/CSV) à un champ
// attendu, quelle que soit la façon dont l'utilisateur les a saisis.
export const normalizeHeader = (header: string) =>
  header
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

// Reconstruit une ligne (objet clé/valeur issu d'un fichier importé) vers un
// jeu de champs canoniques, à partir d'une table d'alias par champ (ex:
// { studentFirstName: ["prenom", "firstname"] }). Générique - la table
// d'alias, elle, reste propre à chaque fonctionnalité d'import (élèves,
// classes...).
export const mapRowByHeaderAliases = (
  row: Record<string, unknown>,
  headerAliases: Record<string, string[]>,
): Record<string, unknown> => {
  const normalizedRow = new Map(
    Object.entries(row).map(([key, value]) => [normalizeHeader(key), value]),
  );

  const mapped: Record<string, unknown> = {};
  for (const [field, aliases] of Object.entries(headerAliases)) {
    const alias = aliases.find((a) => normalizedRow.has(a));
    if (alias !== undefined) {
      mapped[field] = normalizedRow.get(alias);
    }
  }
  return mapped;
};

export const sortByAlphabetical = (arr: any) => {
  return [...arr]?.sort(function (a, b) {
    if (a?.name < b?.name) {
      return -1;
    }
    if (a?.name > b?.name) {
      return 1;
    }
    return 0;
  });
};

export const truncate = (str: any) => {
  return str != null && str.length > 10 ? str.substring(0, 19) + "..." : str;
};
export function get_url_extension(uri: any) {
  if (uri?.type) {
    return uri?.type?.toLowerCase()?.split("/")[1];
  }
  return uri?.toLowerCase()?.split(/[#?]/)[0]?.split(".")?.pop()?.trim();
}

export const getFile = (file: string | any) => {
  if (file && !file?.includes("default.png")) {
    if (file.indexOf("http") === 0) return file;
    return ApiBaseUrl + file;
  }
  return "";
};

export const getFileName = (uri: string) => {
  let name = uri?.split(".")?.length ? uri?.split(".")[0] : uri;

  return name?.includes("mediafiles") ? name?.split("/mediafiles/")[1] : name;
};

export function truncateString(str: any, num: any) {
  // If the length of str is less than or equal to num
  // just return str--don't truncate it.
  if (str?.length <= num) {
    return str;
  }
  // Return str truncated with '...' concatenated to the end of str.
  return str?.slice(0, num) + "...";
}
export function truncateStringReverse(str: any, num: any) {
  if (str?.length <= num) {
    return str;
  }
  return "..." + str?.slice(-num);
}

export const getVideoId = (url: any) => {
  var regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url?.match(regExp);
  return match && match[7].length === 11 ? match[7] : false;
};

export const hasAccess = (user: any, field: any) => {
  let noAccess = false;
  if (!isSuperAdmin(user) && user[field] !== true) {
    noAccess = true;
  }

  return noAccess;
};

export const formatDateWithLabel = (dateString?: string) => {
  if (!dateString) return '';

  const date = moment(dateString);
  const today = moment().startOf('day');
  const yesterday = moment().subtract(1, 'day').startOf('day');

  if (date.isSame(today, 'day')) {
    return "Aujourd'hui";
  } else if (date.isSame(yesterday, 'day')) {
    return "Hier";
  } else {
    return date.format('DD/MM');
  }
};

export const getRole = (item: User) => {
  if (item?.userType === UserType.student) {
    return "Élève"
  }
  if (item?.userType === UserType.teacher) {
    return "Professeur"
  }
  if (item?.userType === UserType.parent) {
    return "Parent"
  }
  if (item?.userType === UserType.independentTeacher) {
    return "Professeur indépendant"
  }

  if (item?.userType === UserType.adult) {
    return "Adulte"
  }
  if (item?.userType === UserType.admin) {
    return "Admin"
  }
  if (item?.userType === UserType.superAdmin) {
    return "Superadmin"
  }
}
export const getRoleClass = (item: User) => {
  if (item?.userType === UserType.student) {
    return "student"
  }
  if (item?.userType === UserType.teacher) {
    return "teacher"
  }
  if (item?.userType === UserType.parent) {
    return "parent"
  }
  if (item?.userType === UserType.independentTeacher) {
    return "independent_teacher"
  }
  if (item?.userType === UserType.adult) {
    return "adult"
  }
}

export const getSubscriptionStatus = (item: any, status?: string) => {
  if (item?.autoRenew === false) {
    return "Résilié"
  }
  if (item?.status === 'active' || status === "active") {
    return "Actif"
  }
  if (item?.status === 'denied' || status === "denied") {
    return "Inactif"
  }
  if (item?.status === 'cancelled' || status === "cancelled") {
    return "Annuler"
  }
  if (item?.status === 'trialing' || status === "trialing") {
    return "Essai gratuit en cours"
  }

  // Aucun document subscription trouvé pour cet utilisateur (ex: élève,
  // parent - seuls profs/établissements ont un abonnement).
  return "Inactif"
}
export const getSubscriptionStatusClass = (item: any, status?: string) => {
  if (item?.autoRenew === false) {
    return "cancelled"
  }
  if (item?.status === 'active' || status === "active") {
    return "active"
  }
  if (item?.status === 'denied' || status === "denied") {
    return "inactive"
  }
  if (item?.status === 'cancelled' || status === "cancelled") {
    return "cancelled"
  }
  if (item?.status === 'trialing' || status === "trialing") {
    return "pending"
  }

  return "inactive"
}

export const getPaymentStatus = (item: any) => {
  if (item?.status === "success") {
    return "Réussi"
  }
  if (item?.status === "failed" || item?.status === "expired") {
    return "Echec"
  }
}
export const getPaymentStatusClass = (item: any) => {
  if (item?.status === "success") {
    return "success"
  }
  if (item?.status === "failed") {
    return "failed"
  }
}

export const getAccessCodeType = (item: any) => {
  if (item?.type === "family") {
    return "Famille"
  }

}
export const getAccessCodeTypeClass = (item: any) => {
  if (item?.status === "family") {
    return "family"
  }

}

export const getAccessCodeStatus = (item: any) => {
  if (item?.status === "valid") {
    return "Valide"
  }
  if (item?.status === "invalid") {
    return "Invalide"
  }
}
export const getAccessCodeStatusClass = (item: any) => {
  if (item?.status === "valid") {
    return "valid"
  }
  if (item?.status === "invalid") {
    return "invalid"
  }
}

export const getSubscriptionPlanRecurrence = (item: any) => {
  if (item?.plan_recurrence === 'monthly') {
    return "Mensuel"
  }
  if (item?.plan_recurrence === 'weekly') {
    return "Hebdomadaire"
  }
  if (item?.plan_recurrence === 'yearly') {
    return "Annuel"
  }
}

export const formatTimestemp = (createdAt: any, formatOut = "DD/MM/YYYY") => {
  if (!createdAt) return "";
  // console.log("createdAt", createdAt)
  let createdDate = new Date(
    createdAt.seconds * 1000 + createdAt.nanoseconds / 1e6
  );
  if (createdAt?._second && createdAt?._nanoseconds) {
    createdDate = new Date(
      createdAt?._seconds * 1000 + createdAt?._nanoseconds / 1e6
    );
  }

  return moment(createdDate).format(formatOut);
};

export const getTimesFromNow = (date: any) => {
  if (!date) return "";
  let createdDate = new Date(
    date.seconds * 1000 + date.nanoseconds / 1e6
  );
  if (date?._second && date?._nanoseconds) {
    createdDate = new Date(
      date?._seconds * 1000 + date?._nanoseconds / 1e6
    );
  }

  return moment(createdDate).fromNow(true);
};

export const formatTimestempToData = (createdAt: any) => {
  if (!createdAt) return "";
  let createdDate = new Date(
    createdAt.seconds * 1000 + createdAt.nanoseconds / 1e6
  );
  if (createdAt?._second && createdAt?._nanoseconds) {
    createdDate = new Date(
      createdAt?._seconds * 1000 + createdAt?._nanoseconds / 1e6
    );
  }

  return createdDate;
};

export const formatNotificationDate = (date: any): string => {
  if (!date) return '';


  const dateToParse = formatTimestempToData(date);
  return moment(dateToParse).calendar(null, {
    sameDay: '[Aujourd\'hui à] HH:mm',
    lastDay: '[Hier à] HH:mm',
    sameElse: 'DD/MM/YYYY [à] HH:mm'
  });
};

type ColorPair = {
  bgColor: string;
  textColor: string;
};

export const generateComplementaryColors = (id: string): ColorPair => {
  // On transforme l'ID en un nombre (hash simple)
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = id.charCodeAt(i) + ((hash << 5) - hash);
  }

  // On utilise le modulo pour rester entre 0 et 360
  const hue = Math.abs(hash) % 360;
  const saturation = 65;

  return {
    bgColor: `hsl(${hue}, ${saturation}%, 92%)`,
    textColor: `hsl(${hue}, ${saturation}%, 35%)`,
  };
};

export const getMsgDate = (date: Timestamp) => {
  const dateJs = date.toDate();
  let value = formatDateHour(dateJs.toISOString());
  const yesterday = moment().subtract(1, "d");

  if (moment(dateJs).isSame(new Date(), "d")) {
    value = moment(dateJs).format("HH:mm");
  } else if (moment(dateJs).isSame(new Date(), "week")) {
    if (moment(dateJs).isSame(yesterday, "d")) {
      value = "Hier";
    } else {
      value = moment(dateJs).format("dddd");
    }
  }
  return value;
};


export type FileType = "image" | "video" | "pdf" | "doc" | "other";
const EXTENSION_MAP: Record<string, FileType> = {
  // images
  jpg: "image", jpeg: "image", png: "image", gif: "image", webp: "image", svg: "image",
  // vidéos
  mp4: "video", mov: "video", avi: "video", mkv: "video", webm: "video",
  // pdf
  pdf: "pdf",
  // documents
  doc: "doc", docx: "doc", xls: "doc", xlsx: "doc", ppt: "doc", pptx: "doc", txt: "doc",
};

function getFileExtension(fileUrl: string): string {
  try {
    const url = new URL(fileUrl);
    const pathname = decodeURIComponent(url.pathname);
    const fileName = pathname.split("/").pop() ?? "";
    const parts = fileName.split(".");
    return parts.length > 1 ? parts.pop()!.toLowerCase() : "";
  } catch {
    const parts = fileUrl.split(".");
    return parts.length > 1 ? parts.pop()!.toLowerCase() : "";
  }
}

function extractFileName(fileUrl: string): string {
  try {
    const url = new URL(fileUrl);
    const pathname = decodeURIComponent(url.pathname);
    return pathname.split("/").pop() ?? "Fichier";
  } catch {
    return fileUrl.split("/").pop() ?? "Fichier";
  }
}

interface FileTypeInfo {
  type: FileType;
  extension: string;
  fileName: string;
}
export function useFileType(fileUrl?: string): FileTypeInfo {
  return useMemo(() => {
    if (!fileUrl) {
      return { type: "other", extension: "", fileName: "" };
    }

    const extension = getFileExtension(fileUrl);
    const type = EXTENSION_MAP[extension] ?? "other";
    const fileName = extractFileName(fileUrl);

    return { type, extension, fileName };
  }, [fileUrl]);
}